import { Card } from 'react-bootstrap'
import { TableTitle } from '../../../../components/atoms/TableTitle'

import * as S from './styles'
import { BillingDetail } from '../../../../domain/models/BillingModel'
import { convertNumberToCurrencyFormat } from '../../../../utils/convertNumberToCurrencyFormat'
import moment from 'moment'

interface BillingCompositionTableProps {
  values: BillingDetail
}

export const BillingCompositionTable = ({
  values
}: BillingCompositionTableProps) => {
  return (
    <S.Wrapper>
      <Card className="table-card">
        <Card.Header>
          <div className="d-flex">
            <TableTitle>Composição do Recebível (UR)</TableTitle>
            <S.CustomLink to="/payments">Ver tudo</S.CustomLink>
          </div>
        </Card.Header>
        <Card.Body className="pb-0">
          <S.CustomTable responsive hover className="mb-0">
            <thead>
              <tr>
                <th>ETAPA</th>
                <th>VALOR TOTAL</th>
                <th>EMISSÃO DO BOLETO</th>
                <th>DATA VENCIMENTO</th>
                <th>DATA PAGAMENTO</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Parcela</td>
                <td>
                  {convertNumberToCurrencyFormat(
                    Number(values?.billing?.value)
                  )}
                </td>
                <td>
                  {values?.bank_billet_transaction ? (
                    <>
                      EMITIDO -{' '}
                      <a
                        target={'_blank'}
                        href={values?.bank_billet_transaction.info.url}
                        rel="noreferrer"
                      >
                        abrir
                      </a>
                    </>
                  ) : values?.billing?.status === 'paid' ||
                    values?.billing?.payment_date ? (
                    'EMITIDO'
                  ) : (
                    'NÃO EMITIDO'
                  )}
                </td>
                <td>{moment(values?.billing.due_date).format('DD/MM/YYYY')}</td>
                <td>
                  {values?.billing?.payment_date
                    ? moment(values?.billing?.payment_date).format('DD/MM/YYYY')
                    : values?.bank_billet_transaction?.paid_at
                    ? moment(values?.bank_billet_transaction.paid_at).format(
                        'DD/MM/YYYY'
                      )
                    : 'NÃO PAGO'}
                </td>
              </tr>
              {values?.billing?.interest_amount &&
                values.billing.interest_amount > 0 && (
                  <tr>
                    <td>Juros</td>
                    <td>
                      {convertNumberToCurrencyFormat(
                        Number(values?.billing?.interest_amount || 0)
                      )}
                    </td>
                    <td>-</td>
                    <td>-</td>
                    <td>
                      {values?.billing?.payment_date
                        ? moment(values?.billing?.payment_date).format(
                            'DD/MM/YYYY'
                          )
                        : 'NÃO PAGO'}
                    </td>
                  </tr>
                )}
              {values?.billing?.fine_amount &&
                values.billing.fine_amount > 0 && (
                  <tr>
                    <td>Multa</td>
                    <td>
                      {convertNumberToCurrencyFormat(
                        Number(values?.billing?.fine_amount || 0)
                      )}
                    </td>
                    <td>-</td>
                    <td>-</td>
                    <td>
                      {values?.billing?.payment_date
                        ? moment(values?.billing?.payment_date).format(
                            'DD/MM/YYYY'
                          )
                        : 'NÃO PAGO'}
                    </td>
                  </tr>
                )}
              {values?.billing?.monetary_correction_amount &&
                values.billing.monetary_correction_amount > 0 && (
                  <tr>
                    <td>Correção monetária</td>
                    <td>
                      {convertNumberToCurrencyFormat(
                        Number(values?.billing?.monetary_correction_amount || 0)
                      )}
                    </td>
                    <td>-</td>
                    <td>-</td>
                    <td>
                      {values?.billing?.payment_date
                        ? moment(values?.billing?.payment_date).format(
                            'DD/MM/YYYY'
                          )
                        : 'NÃO PAGO'}
                    </td>
                  </tr>
                )}
              {values?.billing?.calculated_total &&
                values?.billing?.value &&
                // decimais chegam como string ("1050.00"): comparar como número
                Number(values.billing.calculated_total) >
                  Number(values.billing.value) && (
                  <tr
                    style={{
                      fontWeight: 'bold',
                      borderTop: '2px solid #dee2e6'
                    }}
                  >
                    <td>Total Pago</td>
                    <td>
                      {convertNumberToCurrencyFormat(
                        Number(
                          values?.billing?.calculated_total ||
                            values?.billing?.paid_amount ||
                            values?.billing?.value
                        )
                      )}
                    </td>
                    <td>-</td>
                    <td>-</td>
                    <td>
                      {values?.billing?.payment_date
                        ? moment(values?.billing?.payment_date).format(
                            'DD/MM/YYYY'
                          )
                        : 'NÃO PAGO'}
                    </td>
                  </tr>
                )}
            </tbody>
          </S.CustomTable>
        </Card.Body>
      </Card>
    </S.Wrapper>
  )
}
